/**
 * ScrollToTop — used inside <Router> to ensure every route change
 * resets scroll position to the top of the page (instant, no animation).
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
